var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"main-container"},[_c('el-col',{staticClass:"container-section-main"},[_c('goals-chart-preview',{attrs:{"goals":_vm.currentGoals,"item":_vm.currentGoalItem,"met-goals":_vm.metGoals,"item-type":"seller"}}),_vm._v(" "),_c('goals-chart-preview',{attrs:{"goals":_vm.currentGoals}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49cd7eb9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/goals/goals-seller-detail.vue
// module id = null
// module chunks = 